import React from "react";
import "./rental-date-field.scss";
import { noop } from "../../../common/util";
import { RentalDatePicker } from "./RentalDatePicker";
import dayjs from "dayjs";
import { Dropdown } from "../../components/Dropdown";

const DEFAULT_RENTAL_PERIOD = 4;
const rentalHeaderCopy = "Pick a delivery date 1-2 days before your event";
const toFormattedDate = (date: string | Date) => dayjs(new Date(date)).format("ddd, MMM D");
const rentalPeriod = () => {
  try {
    // @ts-ignore
    return (GC.CategoriesConfig && GC.CategoriesConfig.rentalPeriod) || DEFAULT_RENTAL_PERIOD;
  } catch (e) {
    return DEFAULT_RENTAL_PERIOD;
  }
};

interface RentalDateFieldProps {
  isDressAvailable: Function;
  shouldShowDatePicker?: Function;
  onDatePicked?: Function;
  postcode?: string;
  // string here is YYYY-MM-DD
  initialAppliedDates?: { startDate: string | Date; endDate: string | Date };
}

interface RentalDateFieldState {
  dates: { startDate: string; endDate: string } | undefined | null;
  header: string;
  rentalPeriod: number;
  showingDatePicker: boolean;
}

export class RentalDateField extends React.Component<RentalDateFieldProps, RentalDateFieldState> {
  static defaultProps = {
    onDatePicked: noop()
  };

  constructor(props: RentalDateFieldProps) {
    super(props);

    this.state = {
      dates: this._convertPassedDates(this.props.initialAppliedDates),
      header: rentalHeaderCopy,
      rentalPeriod: rentalPeriod(),
      showingDatePicker: false
    };
  }

  render() {
    return (
      <div className="c-rental-date-field">
        <div
          onClick={this.handleFieldClick}
          className={`c-rental-date-field__input js-rental-date-field input-md text-field text-field--date-picker text-field--new-style
          ${this.state.showingDatePicker && "text-field--new-style-focused"} field-with-label__input`}
        >
          <div className="c-rental-date-field__content">
            {this._renderDeliveryDate() || <span className="text-field__placeholder">Pick your delivery date</span>}
          </div>
        </div>
        <Dropdown
          visible={this.state.showingDatePicker}
          onClickOutsideDropdown={() => {
            return this.setState({ showingDatePicker: false });
          }}
        >
          <RentalDatePicker
            rentalPeriod={this.state.rentalPeriod}
            isDressAvailable={this.props.isDressAvailable}
            onDatePicked={this._onDatePicked}
            header={this.state.header}
            postcode={this.props.postcode}
            onClose={() => {
              this.setState({ showingDatePicker: false });
            }}
          />
        </Dropdown>
      </div>
    );
  }

  componentDidUpdate(prevProps: RentalDateFieldProps, prevState: RentalDateFieldState, snapshot: any) {
    const initial = this.props.initialAppliedDates;
    const previous = prevProps.initialAppliedDates;

    // Only apply initialApplyDates if they are present but different from the previous prop dates
    if (
      initial &&
      (!previous || (previous && initial.startDate !== previous.startDate && initial.endDate !== previous.endDate))
    ) {
      this.setState({ dates: this._convertPassedDates(initial) });
    }
  }

  /**
   * @return {(string | null)}
   */
  _renderDeliveryDate() {
    if (this.state.dates) {
      const { startDate, endDate } = this.state.dates;
      if (startDate !== "" && endDate !== "") {
        return `${toFormattedDate(startDate)} - ${toFormattedDate(endDate)}`;
      }
    }
    return null;
  }

  _onDatePicked = (dates: { startDate: string; endDate: string }) => {
    if (this.props.onDatePicked) {
      this.props.onDatePicked(dates);
    }

    this.setState({
      dates
    });
  };

  handleFieldClick = () => {
    this.setState(prevState => ({
      showingDatePicker: !prevState.showingDatePicker
    }));
  };

  _convertPassedDates = (dates: { startDate: Date | string; endDate: Date | string } | undefined) => {
    let initDates = { startDate: "", endDate: "" };
    if (dates) {
      if (dates.startDate) {
        initDates["startDate"] = dayjs(dates.startDate).format("YYYY-MM-DD");
      }
      if (dates.endDate) {
        initDates["endDate"] = dayjs(dates.endDate).format("YYYY-MM-DD");
      }
    }
    return initDates;
  };
}
